import { createContext } from 'react'


export const articlesContext = createContext()